import { Box } from "@mui/material"
import { BarModal } from "./BarModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CountryData } from "../../types";

interface AddBarProps {
  countries: CountryData[];
  refetchBars: () => void;
}

export const AddBar = ({ countries, refetchBars }: AddBarProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/bars');
  }

  const handleSave = () => {
    navigate('/bars');
    refetchBars();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-bars">
      <BarModal open={open} handleClose={handleClose} handleSave={handleSave} bar={{ }} countries={countries} />
    </Box>
  )
}